import pre_input from '@/components/inputs/pre_input.vue';  
export default {
	props: ['label','md','tag','view_only','placeholder','disabled','condensed','old_value','tooltip','p_icon','a_icon'],
	components:{pre_input},
	computed:{
    	c_tag(){ return this.tag || 'v-flex' },
		c_placeholder() { return this.placeholder || (this.label ? ` Ingrese ${this.label}` : '') },
	},
};
